<template>
  <div>
    <v-autocomplete
      :disabled="aktifmi"
      :rules="rule"
      hide-details=""
      clearable
      append-icon="search"
      :label="$t('Consulate-Code')"
      v-model="val"
      :loading="loading"
      :items="stateKonsolosluk"
      item-text="name"
      item-value="kod"
      :search-input.sync="search1"
      cache-items=""
    >
    </v-autocomplete>
  </div>
</template>

<script>
import tool from "../tools";

export default {
  props: {
    value: {
      type: String,
    },
    tabdeger: {
      type: String,
    },
    rules: {
      type: Boolean,
      default: false,
    },
    aktifmi: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    val: {
      get: function() {
        if(this.value != null){
          this.konsoloslukGetir(this.value);
        }
        return this.value;
      },
      set: function(newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  methods: {
    konsoloslukGetir(v) {
      this.stateKonsolosluk = [];
      this.itemsKonsolosluk = [];
      var isSearching = 0;
      isSearching = v.search("-");
      if (v.length >= 0 && Number(isSearching) == -1) {
        var prm = {
          saticiTipi: 11,
          saticiKodu: null,
          sqlLike: v,
          limit: 100,
        };
        this.loading = true;
        setTimeout(() => {
          tool.http_post(this, "SaticiList", prm).then(
            (response) => {
              this.itemsKonsolosluk = response.body.SaticiList;
              if (this.itemsKonsolosluk != null) {
                for (var i = 0; i < this.itemsKonsolosluk.length; i++) {
                  this.stateKonsolosluk.push({
                    name:
                      this.itemsKonsolosluk[i].Isim +
                      " - " +
                      this.itemsKonsolosluk[i].Kod,
                    kod: this.itemsKonsolosluk[i].Kod,
                  });
                }
              }
            },
            (response) => {}
          );
          this.loading = false;
        }, 500);
      }
    },
  },
  data() {
    return {
      valid: true,
      stateKonsolosluk: [],
      itemsKonsolosluk: [],
      search1: null,
      loading: false,
      items: [],
      rule: [],
    };
  },

  watch: {
    search1(val) {
      val && this.konsoloslukGetir(val);
    },
  },
};
</script>
